import JoiHOC from '../JoiHOC';
import { compose, withState, withHandlers } from 'react-recompose';
import sick from './index';
import { stateHandlers } from '../common/defaultStateHandlers';
import { YEARS_SICK } from '../LegalParameters/Constants';

export default joiSchema => baseComponent => {
	const defaultState = {
		pay: 30000,
		pay_hour: 187.5,
		hours: 80,
		days: 15,
		year: YEARS_SICK[0],
	};

	const setDefaultState = {
		setDefaultState: props => () => {
			props.setState(defaultState);
			props.setResult(null);
			props.setErrors({});
		},
	};

	const onValid = props => props.setResult(sick(props.state));

	stateHandlers.payChangeHandler = props => event => {
		let value = event.target.value;
		const numberValue = parseFloat(value);

		if (!isNaN(numberValue)) {
			value = numberValue;
		}

		props.setState(state => ({
			...state,
			pay_hour: value / 160,
			pay: value,
		}));
		props.setErrors(prevErr => ({
			...prevErr,
			pay_hour: undefined,
		}));
	};

	return compose(
		withState('state', 'setState', defaultState),
		withState('result', 'setResult', null),
		JoiHOC(joiSchema, onValid),
		withHandlers(setDefaultState),
		withHandlers(stateHandlers),
	)(baseComponent);
};
